<div class="report-builder-form">
  <div class="row">
    <select-search-component
      (selectionChange)="onComponentTypeSelectionChange($event)"
      [api_model]="apiModel"
      [value]="config.selectedComponentType"
      [classes]="'fill'"
      class="select-search"
      label="Select Component Type">
    </select-search-component>
    <select-many-search-component
      (selectionChange)="onComponentRelationshipChanged($event)"
      [api_model]="apiModel"
      [custom_filters]="componentRelationshipFilters"
      [value]="config.selectedComponentRelationshipTypes"
      [classes]="'fill'"
      class="select-search"
      label="Select Component relationship types">
    </select-many-search-component>
  </div>
  @if (config.selectedComponentType?.id) {
    <!--Component Type Property Columns-------------------------------------------------------------------------------->
    @if (isComponentTypeLoading$ | async) {
      <div class="loading-container">
        <div class="loading-text">Loading Component Type Columns
          <span class="dots"></span>
        </div>
      </div>
    } @else {
      <h3>
        <mat-icon class="mat-icon mat-icon-no-color" aria-hidden="true"
          (click)="toggleComponentTypeCollapsed()"
          [matTooltip]="isComponentTypeCollapsed ? 'Expand Column Selector' : 'Collapse Column Selector'">{{isComponentTypeCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}}
        </mat-icon>
      Select the Component Type Property columns </h3>
      <div class="sliding-container" [class.collapsed]="isComponentTypeCollapsed">
        <column-selector
          [availableColumns]="availableColumns"
          [selectedColumns]="config.selectedColumns.componentType || []"
          [modelDict]="constantPropertyDict"
          [selectedFilters]="getFilters()"
          (columnsChanged)="columnsChanged($event)"
          (filtersValueChanged)="onFiltersChange($event)"
          (aliasValueChanged)="onPropertyAliasChange($event)">
      </column-selector>
    </div>
  }
  <!--Component Relationship Property Columns-------------------------------------------------------------------------------->
  @if (isRelationshipLoading$ | async) {
    <div class="loading-container">
      <div class="loading-text">Loading Relationship Columns
        <span class="dots"></span>
      </div>
    </div>
  } @else {
    <h3>
      <mat-icon class="mat-icon mat-icon-no-color" aria-hidden="true"
        (click)="isComponentRelationshipTypeCollapsed=!isComponentRelationshipTypeCollapsed;"
        [matTooltip]="isComponentRelationshipTypeCollapsed ? 'Expand Column Selector' : 'Collapse Column Selector'">{{isComponentRelationshipTypeCollapsed ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}}
      </mat-icon>
    Select the Component Relationship Type Property columns </h3>
    @if (config.selectedComponentRelationshipTypes) {
      <mat-tab-group [disableRipple]="true" class="report-builder-form-tabs"
        >
        @for (componentType of config.selectedComponentRelationshipTypes; track componentType) {
          <mat-tab [label]="componentType.attributes.name">
            <column-selector
              [availableColumns]="availableComponentColumns[componentType.id]"
              [selectedColumns]="config.selectedColumns.component[componentType.id] || []"
              [modelDict]="constantPropertyDict"
              [selectedFilters]="getFilters(componentType.id)"
              (columnsChanged)="columnsChanged($event, componentType.id)"
              (filtersValueChanged)="onFiltersChange($event, componentType.id)"
              (aliasValueChanged)="onPropertyAliasChange($event, componentType.id)"
            ></column-selector>
          </mat-tab>
        }
      </mat-tab-group>
    }
  }
}
</div>
